export const GET_SHEETS_SUCCESS = "GET_SHEETS_SUCCESS";
export const SHEETS_ONGOING = "SHEETS_ONGOING";
export const GET_SHEETS_FAILED = "GET_SHEETS_FAILED";

export const GET_SHEET_SUCCESS = "GET_SHEET_SUCCESS";

export const SET_SORT_BY = "SET_SORT_BY";
export const SET_THERE_IS_MORE = "SET_THERE_IS_MORE";
export const GET_NP_SHEETS_SUCCESS = "GET_NP_SHEETS_SUCCESS";
